"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SegmentedControl = function SegmentedControl(_ref) {
  var tabs = _ref.tabs,
    activeKey = _ref.activeKey,
    onChange = _ref.onChange;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex h-[40px] p-[2px] items-center gap-[2px] self-stretch border-b border-[#E1E5E8] bg-white",
    "data-sentry-component": "SegmentedControl",
    "data-sentry-source-file": "SegmentedControl.tsx",
    children: tabs.map(function (_ref2) {
      var key = _ref2.key,
        label = _ref2.label;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: function onClick() {
          return onChange(key);
        },
        className: "flex py-[2px] px-[6px] justify-center items-center gap-[4px] flex-1 self-stretch rounded-[6px] text-[13px] cursor-pointer border-none transition-colors ".concat(activeKey === key ? "bg-primary text-white font-medium" : "bg-transparent text-[#414548] font-normal hover:bg-background-primary-canvas"),
        children: label
      }, key);
    })
  });
};
var _default = exports.default = SegmentedControl;